module.exports = __webpack_public_path__ + "img/supervision_320.5233f4da.webp";